/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import './styles.scss';
import Header from './Header';
import Body from './Body';
import TSectionListContainer from './Container';
import Section from './Section';

const SectionListContainerTemp: any = TSectionListContainer;
SectionListContainerTemp.Section = Section;
SectionListContainerTemp.SectionHeader = Header;
SectionListContainerTemp.SectionBody = Body;

const SectionListContainer = SectionListContainerTemp;

export default SectionListContainer;
export type { SectionListHeaderProps, SectionListBodyProps } from './types';
